import {Pipe, PipeTransform} from "@angular/core";
import {FORM_HELPER} from "../../core/constants";
import {UtilitiesService} from "../../core/_services/utilities.service";

@Pipe({
    name: 'transmission'
})
export class TransmissionPipe implements PipeTransform {
    transmissions = FORM_HELPER.vehicleTransmission;

    transform(transmission: number) {
        if (!transmission) {
            return "";
        }
        let result = "";
        if (UtilitiesService.isNotEmpty(this.transmissions.find((t: any) => transmission == t.value))) {
            result = this.transmissions.find((t: any) => transmission == t.value).label;
        }
        return result;
    }

}
